import React from 'react'
import ProductSang from '../../Products/ProductSang'
import { Link } from 'react-router-dom'
import CategorySangPageORGFA from '../../Products/CategorySangPageORGFA'


function ProductCstegorySang() {
  return (
    <div className='c-Product' >
    <div className='c-titleProduct'>
        <div className='titleProduct'>
            <h1> دسته بندی سنگ </h1>
            <p> گروه سنگ شامل انواع سنگ‌های طبیعی مانند مرمر، گرانیت و تراورتن است که در ساخت‌وساز و دکوراسیون داخلی به کار می‌روند. این سنگ‌ها به دلیل زیبایی و دوام بالا، در کف‌پوش، نما و سطوح تزئینی استفاده می‌شوند </p>
        </div>
    </div>
    
    <div className='c-AllProduct'>
            <div className='AllProduct-Sang'>
                {CategorySangPageORGFA.map((item) => {
                    return (
                        <Link to={`product?name=stone&id=${item.CategoryID}`} key={item.ID} onClick={() => window.scrollTo(0, 0)}>
                            <div className="p-Product" >
                                <div className='c-img'> <img  src={item.ImageURL} alt="محصول 1" /> </div>
                                <h4> {item.Name} </h4>
                            </div>
                        </Link>
                    )
                })}
            </div>
    </div>
</div>
  )
}

export default ProductCstegorySang
